module.exports = __webpack_public_path__ + "fonts/symantec_ico@2x.0a0bc7472711ea6f94bf95aff6782fde.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/symantec_ico@2x.png
// module id = 791
// module chunks = 9